export const validateReliefAllotments = (totalReliefEmployees, calcReliefAllotments, schedMonth, schedYear) => {
  if (
    schedMonth !== "" &&
    schedYear !== "" &&
    ((totalReliefEmployees === 0 &&
      (calcReliefAllotments.amOrPmCount !== 0 ||
        (calcReliefAllotments.amCount !== 0 && calcReliefAllotments.pmCount !== 0))) || // If total emp's zero, but we have any of the amOrPmCount/amCount/pmCount present means Relief emp's changed to zero after calculations
      (totalReliefEmployees > 0 && totalReliefEmployees < 12 && calcReliefAllotments.amOrPmCount !== 1) || //If total emp's between 1 to 11, we need to have AM OR PM
      (totalReliefEmployees >= 12 && calcReliefAllotments.amCount !== 1 && calcReliefAllotments.pmCount !== 1)) //If total emp's >= 12, we need to have both AM and PM
  ) {
    return "Incorrect number of allotments for Relief Employees";
  }
  return "";
};

export const validateStandardAllotments = (totalStandardEmployees, totalAllotments, schedMonth, schedYear) => {
  if (schedMonth !== "" && schedYear !== "" && totalStandardEmployees > totalAllotments) {
    return "Incorrect number of allotments for Standard Employees";
  }
  return "";
};

export const getStandardReliefMissingCount = (bidGroup) => {
  return bidGroup?.filter((employee) => !employee.standardRelief && !employee.isRemoved).length;
};
